import KC_UIText from "../../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../../designsystem/ds_commons";
import KC_Button from "../../../../../designsystem/KC_Button/KC_Button";
import React from "react";
import KC_Toggle from "../../../../../designsystem/KC_FormInput/KC_Toggle";
import { tt } from "../../../../../utils/i18n/i18n";
import { EmailTemplateKeyType } from "../../../../../components/modal/EmailTemplates/EmailTemplate";
import { Config, MarketingAutomationConfigKeys } from "kadow-jetpack-model";
import NiceModal from "@ebay/nice-modal-react";
import PostPaymentModal from "../../../../../components/modal/ConfirmPayment/PostPaymentModal";
import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import shouldDisplayKey from "../components/shouldDisplayKey";

export const renderDefaultScenarios = (
  config: Config | null,
  accountToDisplay: ManagedAccount | undefined | null,
  onClick?: (maKey: EmailTemplateKeyType) => void
) => {
  return (
    <>
      {DEFAULT_SCENARIOS.map((scenario, idx) => {
        if (!shouldDisplayKey(accountToDisplay, scenario.id)) {
          return null;
        }

        if (scenario.id === "ml_win" || scenario.id === "ml_loser") {
          // non-SaaS configs
          if (!config?.f && config?.dml) {
            return null;
          }

          // SaaS configs
          if (!config?.f?.ml || config?.dml) {
            return null;
          }
        }

        return (
          <DefaultScenariosRow
            scenario={scenario}
            key={scenario.id + idx}
            onClick={onClick}
          />
        );
      })}
    </>
  );
};

interface Props {
  scenario: DefaultScenario;
  onClick?: (maKey: EmailTemplateKeyType) => void;
}

export function DefaultScenariosRow({ scenario, onClick }: Props) {
  const handleToggleClick = async () => {
    await NiceModal.show(PostPaymentModal, {
      headerText: tt("marketing_automation_scenario_cannot_be_disabled_title"),
      bodyText: tt("marketing_automation_scenario_cannot_be_disabled_message"),
      buttonText: tt("ok")
    });
  };

  return (
    <tr>
      <td>
        <div className="w-100 d-flex gap-sm justify-content-center align-items-center">
          <KC_Toggle
            id={scenario.id}
            isChecked={true}
            onToggle={handleToggleClick}
          />
          <KC_UIText weight={KC_Weights.reg} text={scenario.text} />
        </div>
      </td>
      <td className="d-none d-lg-table-cell">
        <KC_UIText weight={KC_Weights.reg} text={scenario.sendDate} />
      </td>
      <td className="text-center d-none d-lg-table-cell">
        <KC_Button
          isTransparent={true}
          text={tt("view")}
          className="text-semi-bold d-flex"
          onClick={() => onClick?.(scenario.id)}
        />
      </td>
    </tr>
  );
}

interface DefaultScenario {
  id: EmailTemplateKeyType;
  text: string;
  sendDate: string;
}

const DEFAULT_SCENARIOS: DefaultScenario[] = [
  {
    id: "win",
    text: tt("marketing_automation_win_email_title"),
    sendDate: tt("marketing_automation_win_email_description")
  },
  {
    id: "ml_win",
    text: tt("marketing_automation_lottery_win_title"),
    sendDate: tt("marketing_automation_lottery_win_description")
  },
  {
    id: MarketingAutomationConfigKeys.ml_loser,
    text: tt("marketing_automation_lottery_loss_title"),
    sendDate: tt("marketing_automation_lottery_loss_description")
  }
];

export const CUSTOMER_OF_THE_MONTH_SCENARIO: DefaultScenario = {
  id: "ltycm",
  text: tt("ma_loyalty_customer_of_the_month_title"),
  sendDate: tt("ma_loyalty_customer_of_the_month_desc")
};
